// Copyright Exafunction, Inc.
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { BrowserClickInteraction, BrowserCodeBlockScopeItem, BrowserInstallationStatus, BrowserPageMetadata, BrowserPageScopeItem, BrowserScrollInteraction, ConsoleLogScopeItem, DOMElementScopeItem, DOMTree, ImageData, KnowledgeBaseItem, TextBlock } from "../codeium_common_pb/codeium_common_pb";
/**
 * Browser type options for browser preview
 *
 * @generated from enum exa.browser_preview_pb.BrowserType
 */
export var BrowserType;
(function (BrowserType) {
    /**
     * @generated from enum value: BROWSER_TYPE_UNSPECIFIED = 0;
     */
    BrowserType[BrowserType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * default
     *
     * @generated from enum value: BROWSER_TYPE_CHROMIUM = 1;
     */
    BrowserType[BrowserType["CHROMIUM"] = 1] = "CHROMIUM";
    /**
     * @generated from enum value: BROWSER_TYPE_FIREFOX = 2;
     */
    BrowserType[BrowserType["FIREFOX"] = 2] = "FIREFOX";
    /**
     * @generated from enum value: BROWSER_TYPE_WEBKIT = 3;
     */
    BrowserType[BrowserType["WEBKIT"] = 3] = "WEBKIT";
})(BrowserType || (BrowserType = {}));
// Retrieve enum metadata with: proto3.getEnumType(BrowserType)
proto3.util.setEnumType(BrowserType, "exa.browser_preview_pb.BrowserType", [
    { no: 0, name: "BROWSER_TYPE_UNSPECIFIED" },
    { no: 1, name: "BROWSER_TYPE_CHROMIUM" },
    { no: 2, name: "BROWSER_TYPE_FIREFOX" },
    { no: 3, name: "BROWSER_TYPE_WEBKIT" },
]);
/**
 * @generated from enum exa.browser_preview_pb.LogLevel
 */
export var LogLevel;
(function (LogLevel) {
    /**
     * @generated from enum value: LOG_LEVEL_UNSPECIFIED = 0;
     */
    LogLevel[LogLevel["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: LOG_LEVEL_DEBUG = 1;
     */
    LogLevel[LogLevel["DEBUG"] = 1] = "DEBUG";
    /**
     * @generated from enum value: LOG_LEVEL_INFO = 2;
     */
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    /**
     * @generated from enum value: LOG_LEVEL_WARNING = 3;
     */
    LogLevel[LogLevel["WARNING"] = 3] = "WARNING";
    /**
     * @generated from enum value: LOG_LEVEL_ERROR = 4;
     */
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
})(LogLevel || (LogLevel = {}));
// Retrieve enum metadata with: proto3.getEnumType(LogLevel)
proto3.util.setEnumType(LogLevel, "exa.browser_preview_pb.LogLevel", [
    { no: 0, name: "LOG_LEVEL_UNSPECIFIED" },
    { no: 1, name: "LOG_LEVEL_DEBUG" },
    { no: 2, name: "LOG_LEVEL_INFO" },
    { no: 3, name: "LOG_LEVEL_WARNING" },
    { no: 4, name: "LOG_LEVEL_ERROR" },
]);
/**
 * @generated from message exa.browser_preview_pb.SendDOMElementRequest
 */
export class SendDOMElementRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SendDOMElementRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SendDOMElementRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SendDOMElementRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SendDOMElementRequest, a, b);
    }
}
SendDOMElementRequest.runtime = proto3;
SendDOMElementRequest.typeName = "exa.browser_preview_pb.SendDOMElementRequest";
SendDOMElementRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "dom_element", kind: "message", T: DOMElementScopeItem },
]);
/**
 * @generated from message exa.browser_preview_pb.SendDOMElementResponse
 */
export class SendDOMElementResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SendDOMElementResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SendDOMElementResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SendDOMElementResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SendDOMElementResponse, a, b);
    }
}
SendDOMElementResponse.runtime = proto3;
SendDOMElementResponse.typeName = "exa.browser_preview_pb.SendDOMElementResponse";
SendDOMElementResponse.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.SendScreenshotRequest
 */
export class SendScreenshotRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SendScreenshotRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SendScreenshotRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SendScreenshotRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SendScreenshotRequest, a, b);
    }
}
SendScreenshotRequest.runtime = proto3;
SendScreenshotRequest.typeName = "exa.browser_preview_pb.SendScreenshotRequest";
SendScreenshotRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "image", kind: "message", T: ImageData },
]);
/**
 * @generated from message exa.browser_preview_pb.SendScreenshotResponse
 */
export class SendScreenshotResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SendScreenshotResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SendScreenshotResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SendScreenshotResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SendScreenshotResponse, a, b);
    }
}
SendScreenshotResponse.runtime = proto3;
SendScreenshotResponse.typeName = "exa.browser_preview_pb.SendScreenshotResponse";
SendScreenshotResponse.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.SendConsoleOutputRequest
 */
export class SendConsoleOutputRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SendConsoleOutputRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SendConsoleOutputRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SendConsoleOutputRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SendConsoleOutputRequest, a, b);
    }
}
SendConsoleOutputRequest.runtime = proto3;
SendConsoleOutputRequest.typeName = "exa.browser_preview_pb.SendConsoleOutputRequest";
SendConsoleOutputRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "console_log", kind: "message", T: ConsoleLogScopeItem },
]);
/**
 * @generated from message exa.browser_preview_pb.SendConsoleOutputResponse
 */
export class SendConsoleOutputResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SendConsoleOutputResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SendConsoleOutputResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SendConsoleOutputResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SendConsoleOutputResponse, a, b);
    }
}
SendConsoleOutputResponse.runtime = proto3;
SendConsoleOutputResponse.typeName = "exa.browser_preview_pb.SendConsoleOutputResponse";
SendConsoleOutputResponse.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.StartBrowserRequest
 */
export class StartBrowserRequest extends Message {
    constructor(data) {
        super();
        /**
         * URL to navigate to. This should be a valid URL and cannot be empty.
         *
         * @generated from field: string url = 1;
         */
        this.url = "";
        /**
         * Browser type to use. If unspecified, CHROMIUM will be used.
         *
         * @generated from field: exa.browser_preview_pb.BrowserType browser_type = 2;
         */
        this.browserType = BrowserType.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new StartBrowserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartBrowserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartBrowserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartBrowserRequest, a, b);
    }
}
StartBrowserRequest.runtime = proto3;
StartBrowserRequest.typeName = "exa.browser_preview_pb.StartBrowserRequest";
StartBrowserRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "browser_type", kind: "enum", T: proto3.getEnumType(BrowserType) },
]);
/**
 * @generated from message exa.browser_preview_pb.StartBrowserResponse
 */
export class StartBrowserResponse extends Message {
    constructor(data) {
        super();
        /**
         * The ID of the browser page that was opened. This can be used for subsequent operations
         * like navigation or capturing elements.
         *
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new StartBrowserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartBrowserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartBrowserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartBrowserResponse, a, b);
    }
}
StartBrowserResponse.runtime = proto3;
StartBrowserResponse.typeName = "exa.browser_preview_pb.StartBrowserResponse";
StartBrowserResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.browser_preview_pb.StopBrowserRequest
 */
export class StopBrowserRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new StopBrowserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StopBrowserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StopBrowserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StopBrowserRequest, a, b);
    }
}
StopBrowserRequest.runtime = proto3;
StopBrowserRequest.typeName = "exa.browser_preview_pb.StopBrowserRequest";
StopBrowserRequest.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.StopBrowserResponse
 */
export class StopBrowserResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new StopBrowserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StopBrowserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StopBrowserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StopBrowserResponse, a, b);
    }
}
StopBrowserResponse.runtime = proto3;
StopBrowserResponse.typeName = "exa.browser_preview_pb.StopBrowserResponse";
StopBrowserResponse.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.GetBrowserInstallationStatusRequest
 */
export class GetBrowserInstallationStatusRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetBrowserInstallationStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBrowserInstallationStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBrowserInstallationStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBrowserInstallationStatusRequest, a, b);
    }
}
GetBrowserInstallationStatusRequest.runtime = proto3;
GetBrowserInstallationStatusRequest.typeName = "exa.browser_preview_pb.GetBrowserInstallationStatusRequest";
GetBrowserInstallationStatusRequest.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.GetBrowserInstallationStatusResponse
 */
export class GetBrowserInstallationStatusResponse extends Message {
    constructor(data) {
        super();
        /**
         * Installation status of the Playwright browser download.
         *
         * @generated from field: exa.codeium_common_pb.BrowserInstallationStatus status = 1;
         */
        this.status = BrowserInstallationStatus.UNSPECIFIED;
        /**
         * Error message if installation failed. If successful, this will be empty.
         *
         * @generated from field: string installation_error = 2;
         */
        this.installationError = "";
        /**
         * Path to the browser cache directory.
         *
         * @generated from field: string browser_cache_dir_uri = 3;
         */
        this.browserCacheDirUri = "";
        /**
         * Size of the browser cache directory in bytes.
         *
         * @generated from field: uint64 browser_cache_dir_num_bytes = 4;
         */
        this.browserCacheDirNumBytes = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GetBrowserInstallationStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBrowserInstallationStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBrowserInstallationStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBrowserInstallationStatusResponse, a, b);
    }
}
GetBrowserInstallationStatusResponse.runtime = proto3;
GetBrowserInstallationStatusResponse.typeName = "exa.browser_preview_pb.GetBrowserInstallationStatusResponse";
GetBrowserInstallationStatusResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(BrowserInstallationStatus) },
    { no: 2, name: "installation_error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "browser_cache_dir_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "browser_cache_dir_num_bytes", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
]);
/**
 * @generated from message exa.browser_preview_pb.ListPagesRequest
 */
export class ListPagesRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ListPagesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPagesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPagesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPagesRequest, a, b);
    }
}
ListPagesRequest.runtime = proto3;
ListPagesRequest.typeName = "exa.browser_preview_pb.ListPagesRequest";
ListPagesRequest.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.ListPagesResponse
 */
export class ListPagesResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated exa.codeium_common_pb.BrowserPageMetadata pages = 1;
         */
        this.pages = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ListPagesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPagesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPagesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPagesResponse, a, b);
    }
}
ListPagesResponse.runtime = proto3;
ListPagesResponse.typeName = "exa.browser_preview_pb.ListPagesResponse";
ListPagesResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "pages", kind: "message", T: BrowserPageMetadata, repeated: true },
]);
/**
 * @generated from message exa.browser_preview_pb.NavigateToURLRequest
 */
export class NavigateToURLRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        /**
         * @generated from field: string url = 2;
         */
        this.url = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new NavigateToURLRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NavigateToURLRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NavigateToURLRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NavigateToURLRequest, a, b);
    }
}
NavigateToURLRequest.runtime = proto3;
NavigateToURLRequest.typeName = "exa.browser_preview_pb.NavigateToURLRequest";
NavigateToURLRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.browser_preview_pb.NavigateToURLResponse
 */
export class NavigateToURLResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new NavigateToURLResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NavigateToURLResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NavigateToURLResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NavigateToURLResponse, a, b);
    }
}
NavigateToURLResponse.runtime = proto3;
NavigateToURLResponse.typeName = "exa.browser_preview_pb.NavigateToURLResponse";
NavigateToURLResponse.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.CaptureDOMElementRequest
 */
export class CaptureDOMElementRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureDOMElementRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureDOMElementRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureDOMElementRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureDOMElementRequest, a, b);
    }
}
CaptureDOMElementRequest.runtime = proto3;
CaptureDOMElementRequest.typeName = "exa.browser_preview_pb.CaptureDOMElementRequest";
CaptureDOMElementRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dom_element", kind: "message", T: DOMElementScopeItem },
]);
/**
 * @generated from message exa.browser_preview_pb.CaptureDOMElementResponse
 */
export class CaptureDOMElementResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureDOMElementResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureDOMElementResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureDOMElementResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureDOMElementResponse, a, b);
    }
}
CaptureDOMElementResponse.runtime = proto3;
CaptureDOMElementResponse.typeName = "exa.browser_preview_pb.CaptureDOMElementResponse";
CaptureDOMElementResponse.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.CaptureScreenshotRequest
 */
export class CaptureScreenshotRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureScreenshotRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureScreenshotRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureScreenshotRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureScreenshotRequest, a, b);
    }
}
CaptureScreenshotRequest.runtime = proto3;
CaptureScreenshotRequest.typeName = "exa.browser_preview_pb.CaptureScreenshotRequest";
CaptureScreenshotRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.browser_preview_pb.CaptureScreenshotResponse
 */
export class CaptureScreenshotResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureScreenshotResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureScreenshotResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureScreenshotResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureScreenshotResponse, a, b);
    }
}
CaptureScreenshotResponse.runtime = proto3;
CaptureScreenshotResponse.typeName = "exa.browser_preview_pb.CaptureScreenshotResponse";
CaptureScreenshotResponse.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.CaptureElementScreenshotRequest
 */
export class CaptureElementScreenshotRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        /**
         * @generated from field: string selector = 2;
         */
        this.selector = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureElementScreenshotRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureElementScreenshotRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureElementScreenshotRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureElementScreenshotRequest, a, b);
    }
}
CaptureElementScreenshotRequest.runtime = proto3;
CaptureElementScreenshotRequest.typeName = "exa.browser_preview_pb.CaptureElementScreenshotRequest";
CaptureElementScreenshotRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "selector", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.browser_preview_pb.CaptureElementScreenshotResponse
 */
export class CaptureElementScreenshotResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureElementScreenshotResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureElementScreenshotResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureElementScreenshotResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureElementScreenshotResponse, a, b);
    }
}
CaptureElementScreenshotResponse.runtime = proto3;
CaptureElementScreenshotResponse.typeName = "exa.browser_preview_pb.CaptureElementScreenshotResponse";
CaptureElementScreenshotResponse.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.CaptureElementInnerTextRequest
 */
export class CaptureElementInnerTextRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        /**
         * @generated from field: string url = 2;
         */
        this.url = "";
        /**
         * @generated from field: string selector = 3;
         */
        this.selector = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureElementInnerTextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureElementInnerTextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureElementInnerTextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureElementInnerTextRequest, a, b);
    }
}
CaptureElementInnerTextRequest.runtime = proto3;
CaptureElementInnerTextRequest.typeName = "exa.browser_preview_pb.CaptureElementInnerTextRequest";
CaptureElementInnerTextRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "selector", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.browser_preview_pb.CaptureElementInnerTextResponse
 */
export class CaptureElementInnerTextResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureElementInnerTextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureElementInnerTextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureElementInnerTextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureElementInnerTextResponse, a, b);
    }
}
CaptureElementInnerTextResponse.runtime = proto3;
CaptureElementInnerTextResponse.typeName = "exa.browser_preview_pb.CaptureElementInnerTextResponse";
CaptureElementInnerTextResponse.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.CaptureConsoleOutputRequest
 */
export class CaptureConsoleOutputRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        /**
         * @generated from field: repeated exa.browser_preview_pb.LogLevel log_levels = 2;
         */
        this.logLevels = [];
        /**
         * @generated from field: bool user_manually_triggered = 3;
         */
        this.userManuallyTriggered = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureConsoleOutputRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureConsoleOutputRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureConsoleOutputRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureConsoleOutputRequest, a, b);
    }
}
CaptureConsoleOutputRequest.runtime = proto3;
CaptureConsoleOutputRequest.typeName = "exa.browser_preview_pb.CaptureConsoleOutputRequest";
CaptureConsoleOutputRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "log_levels", kind: "enum", T: proto3.getEnumType(LogLevel), repeated: true },
    { no: 3, name: "user_manually_triggered", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message exa.browser_preview_pb.CaptureConsoleOutputResponse
 */
export class CaptureConsoleOutputResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureConsoleOutputResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureConsoleOutputResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureConsoleOutputResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureConsoleOutputResponse, a, b);
    }
}
CaptureConsoleOutputResponse.runtime = proto3;
CaptureConsoleOutputResponse.typeName = "exa.browser_preview_pb.CaptureConsoleOutputResponse";
CaptureConsoleOutputResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "console_logs", kind: "message", T: ConsoleLogScopeItem },
]);
/**
 * @generated from message exa.browser_preview_pb.CaptureAllTextRequest
 */
export class CaptureAllTextRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureAllTextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureAllTextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureAllTextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureAllTextRequest, a, b);
    }
}
CaptureAllTextRequest.runtime = proto3;
CaptureAllTextRequest.typeName = "exa.browser_preview_pb.CaptureAllTextRequest";
CaptureAllTextRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "browser_page_item", kind: "message", T: BrowserPageScopeItem },
]);
/**
 * @generated from message exa.browser_preview_pb.CaptureAllTextResponse
 */
export class CaptureAllTextResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureAllTextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureAllTextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureAllTextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureAllTextResponse, a, b);
    }
}
CaptureAllTextResponse.runtime = proto3;
CaptureAllTextResponse.typeName = "exa.browser_preview_pb.CaptureAllTextResponse";
CaptureAllTextResponse.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.CaptureSelectedTextRequest
 */
export class CaptureSelectedTextRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureSelectedTextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSelectedTextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSelectedTextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSelectedTextRequest, a, b);
    }
}
CaptureSelectedTextRequest.runtime = proto3;
CaptureSelectedTextRequest.typeName = "exa.browser_preview_pb.CaptureSelectedTextRequest";
CaptureSelectedTextRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "text_block", kind: "message", T: TextBlock },
]);
/**
 * @generated from message exa.browser_preview_pb.CaptureSelectedTextResponse
 */
export class CaptureSelectedTextResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureSelectedTextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSelectedTextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSelectedTextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSelectedTextResponse, a, b);
    }
}
CaptureSelectedTextResponse.runtime = proto3;
CaptureSelectedTextResponse.typeName = "exa.browser_preview_pb.CaptureSelectedTextResponse";
CaptureSelectedTextResponse.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.CaptureCodeBlockRequest
 */
export class CaptureCodeBlockRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureCodeBlockRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureCodeBlockRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureCodeBlockRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureCodeBlockRequest, a, b);
    }
}
CaptureCodeBlockRequest.runtime = proto3;
CaptureCodeBlockRequest.typeName = "exa.browser_preview_pb.CaptureCodeBlockRequest";
CaptureCodeBlockRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "browser_code_block_item", kind: "message", T: BrowserCodeBlockScopeItem },
]);
/**
 * @generated from message exa.browser_preview_pb.CaptureCodeBlockResponse
 */
export class CaptureCodeBlockResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureCodeBlockResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureCodeBlockResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureCodeBlockResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureCodeBlockResponse, a, b);
    }
}
CaptureCodeBlockResponse.runtime = proto3;
CaptureCodeBlockResponse.typeName = "exa.browser_preview_pb.CaptureCodeBlockResponse";
CaptureCodeBlockResponse.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.CaptureLogBlockRequest
 */
export class CaptureLogBlockRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureLogBlockRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureLogBlockRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureLogBlockRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureLogBlockRequest, a, b);
    }
}
CaptureLogBlockRequest.runtime = proto3;
CaptureLogBlockRequest.typeName = "exa.browser_preview_pb.CaptureLogBlockRequest";
CaptureLogBlockRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "browser_log_block_item", kind: "message", T: ConsoleLogScopeItem },
]);
/**
 * @generated from message exa.browser_preview_pb.CaptureLogBlockResponse
 */
export class CaptureLogBlockResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureLogBlockResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureLogBlockResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureLogBlockResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureLogBlockResponse, a, b);
    }
}
CaptureLogBlockResponse.runtime = proto3;
CaptureLogBlockResponse.typeName = "exa.browser_preview_pb.CaptureLogBlockResponse";
CaptureLogBlockResponse.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.CaptureClickEventRequest
 */
export class CaptureClickEventRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureClickEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureClickEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureClickEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureClickEventRequest, a, b);
    }
}
CaptureClickEventRequest.runtime = proto3;
CaptureClickEventRequest.typeName = "exa.browser_preview_pb.CaptureClickEventRequest";
CaptureClickEventRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "click_interaction", kind: "message", T: BrowserClickInteraction },
]);
/**
 * @generated from message exa.browser_preview_pb.CaptureClickEventResponse
 */
export class CaptureClickEventResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureClickEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureClickEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureClickEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureClickEventResponse, a, b);
    }
}
CaptureClickEventResponse.runtime = proto3;
CaptureClickEventResponse.typeName = "exa.browser_preview_pb.CaptureClickEventResponse";
CaptureClickEventResponse.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.CaptureScrollEventRequest
 */
export class CaptureScrollEventRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureScrollEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureScrollEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureScrollEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureScrollEventRequest, a, b);
    }
}
CaptureScrollEventRequest.runtime = proto3;
CaptureScrollEventRequest.typeName = "exa.browser_preview_pb.CaptureScrollEventRequest";
CaptureScrollEventRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "scroll_interaction", kind: "message", T: BrowserScrollInteraction },
]);
/**
 * @generated from message exa.browser_preview_pb.CaptureScrollEventResponse
 */
export class CaptureScrollEventResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureScrollEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureScrollEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureScrollEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureScrollEventResponse, a, b);
    }
}
CaptureScrollEventResponse.runtime = proto3;
CaptureScrollEventResponse.typeName = "exa.browser_preview_pb.CaptureScrollEventResponse";
CaptureScrollEventResponse.fields = proto3.util.newFieldList(() => []);
/**
 * CapturePageContentsRequest captures the structured contents of a web page.
 *
 * @generated from message exa.browser_preview_pb.CapturePageContentsRequest
 */
export class CapturePageContentsRequest extends Message {
    constructor(data) {
        super();
        /**
         * ID of the page to capture contents from
         *
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        /**
         * URL of the page to capture contents from
         *
         * @generated from field: string url = 2;
         */
        this.url = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CapturePageContentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePageContentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePageContentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePageContentsRequest, a, b);
    }
}
CapturePageContentsRequest.runtime = proto3;
CapturePageContentsRequest.typeName = "exa.browser_preview_pb.CapturePageContentsRequest";
CapturePageContentsRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * CapturePageContentsResponse is the response for the CapturePageContents RPC.
 *
 * @generated from message exa.browser_preview_pb.CapturePageContentsResponse
 */
export class CapturePageContentsResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CapturePageContentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePageContentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePageContentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePageContentsResponse, a, b);
    }
}
CapturePageContentsResponse.runtime = proto3;
CapturePageContentsResponse.typeName = "exa.browser_preview_pb.CapturePageContentsResponse";
CapturePageContentsResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "web_document", kind: "message", T: KnowledgeBaseItem },
]);
/**
 * @generated from message exa.browser_preview_pb.CapturePageMetadataRequest
 */
export class CapturePageMetadataRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CapturePageMetadataRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePageMetadataRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePageMetadataRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePageMetadataRequest, a, b);
    }
}
CapturePageMetadataRequest.runtime = proto3;
CapturePageMetadataRequest.typeName = "exa.browser_preview_pb.CapturePageMetadataRequest";
CapturePageMetadataRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.browser_preview_pb.CapturePageMetadataResponse
 */
export class CapturePageMetadataResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CapturePageMetadataResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePageMetadataResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePageMetadataResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePageMetadataResponse, a, b);
    }
}
CapturePageMetadataResponse.runtime = proto3;
CapturePageMetadataResponse.typeName = "exa.browser_preview_pb.CapturePageMetadataResponse";
CapturePageMetadataResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_metadata", kind: "message", T: BrowserPageMetadata },
]);
/**
 * @generated from message exa.browser_preview_pb.ExecuteJavaScriptRequest
 */
export class ExecuteJavaScriptRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        /**
         * @generated from field: string javascript_source = 2;
         */
        this.javascriptSource = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ExecuteJavaScriptRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecuteJavaScriptRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecuteJavaScriptRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecuteJavaScriptRequest, a, b);
    }
}
ExecuteJavaScriptRequest.runtime = proto3;
ExecuteJavaScriptRequest.typeName = "exa.browser_preview_pb.ExecuteJavaScriptRequest";
ExecuteJavaScriptRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "javascript_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.browser_preview_pb.ExecuteJavaScriptResponse
 */
export class ExecuteJavaScriptResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string result = 1;
         */
        this.result = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ExecuteJavaScriptResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecuteJavaScriptResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecuteJavaScriptResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecuteJavaScriptResponse, a, b);
    }
}
ExecuteJavaScriptResponse.runtime = proto3;
ExecuteJavaScriptResponse.typeName = "exa.browser_preview_pb.ExecuteJavaScriptResponse";
ExecuteJavaScriptResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "result", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.browser_preview_pb.CapturePageScreenshotRequest
 */
export class CapturePageScreenshotRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        /**
         * if true, captures full page; if false (default), captures current viewport.
         *
         * @generated from field: bool full_page = 2;
         */
        this.fullPage = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CapturePageScreenshotRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePageScreenshotRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePageScreenshotRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePageScreenshotRequest, a, b);
    }
}
CapturePageScreenshotRequest.runtime = proto3;
CapturePageScreenshotRequest.typeName = "exa.browser_preview_pb.CapturePageScreenshotRequest";
CapturePageScreenshotRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "full_page", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message exa.browser_preview_pb.CapturePageScreenshotResponse
 */
export class CapturePageScreenshotResponse extends Message {
    constructor(data) {
        super();
        /**
         * whether the captured screenshot is full page.
         *
         * @generated from field: bool full_page = 2;
         */
        this.fullPage = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CapturePageScreenshotResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePageScreenshotResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePageScreenshotResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePageScreenshotResponse, a, b);
    }
}
CapturePageScreenshotResponse.runtime = proto3;
CapturePageScreenshotResponse.typeName = "exa.browser_preview_pb.CapturePageScreenshotResponse";
CapturePageScreenshotResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "screenshot", kind: "message", T: ImageData },
    { no: 2, name: "full_page", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message exa.browser_preview_pb.ClickPixelRequest
 */
export class ClickPixelRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        /**
         * X coordinate of the pixel to click
         *
         * @generated from field: int32 x = 2;
         */
        this.x = 0;
        /**
         * Y coordinate of the pixel to click
         *
         * @generated from field: int32 y = 3;
         */
        this.y = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ClickPixelRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClickPixelRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClickPixelRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClickPixelRequest, a, b);
    }
}
ClickPixelRequest.runtime = proto3;
ClickPixelRequest.typeName = "exa.browser_preview_pb.ClickPixelRequest";
ClickPixelRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "x", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "y", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message exa.browser_preview_pb.ClickPixelResponse
 */
export class ClickPixelResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ClickPixelResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClickPixelResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClickPixelResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClickPixelResponse, a, b);
    }
}
ClickPixelResponse.runtime = proto3;
ClickPixelResponse.typeName = "exa.browser_preview_pb.ClickPixelResponse";
ClickPixelResponse.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.browser_preview_pb.CaptureDOMTreeRequest
 */
export class CaptureDOMTreeRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureDOMTreeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureDOMTreeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureDOMTreeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureDOMTreeRequest, a, b);
    }
}
CaptureDOMTreeRequest.runtime = proto3;
CaptureDOMTreeRequest.typeName = "exa.browser_preview_pb.CaptureDOMTreeRequest";
CaptureDOMTreeRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.browser_preview_pb.CaptureDOMTreeResponse
 */
export class CaptureDOMTreeResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureDOMTreeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureDOMTreeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureDOMTreeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureDOMTreeResponse, a, b);
    }
}
CaptureDOMTreeResponse.runtime = proto3;
CaptureDOMTreeResponse.typeName = "exa.browser_preview_pb.CaptureDOMTreeResponse";
CaptureDOMTreeResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "dom_tree", kind: "message", T: DOMTree },
]);
/**
 * RegisterPageRequest is sent when a new page is opened by the extension
 *
 * @generated from message exa.browser_preview_pb.RegisterPageRequest
 */
export class RegisterPageRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        /**
         * @generated from field: string url = 2;
         */
        this.url = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RegisterPageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegisterPageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegisterPageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegisterPageRequest, a, b);
    }
}
RegisterPageRequest.runtime = proto3;
RegisterPageRequest.typeName = "exa.browser_preview_pb.RegisterPageRequest";
RegisterPageRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "timestamp", kind: "message", T: Timestamp },
]);
/**
 * RegisterPageResponse is the response for the RegisterPage RPC
 *
 * @generated from message exa.browser_preview_pb.RegisterPageResponse
 */
export class RegisterPageResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RegisterPageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegisterPageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegisterPageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegisterPageResponse, a, b);
    }
}
RegisterPageResponse.runtime = proto3;
RegisterPageResponse.typeName = "exa.browser_preview_pb.RegisterPageResponse";
RegisterPageResponse.fields = proto3.util.newFieldList(() => []);
/**
 * RecordBrowserAnalyticsRequest is sent when the extension needs to record comprehensive browser analytics
 *
 * @generated from message exa.browser_preview_pb.RecordBrowserAnalyticsRequest
 */
export class RecordBrowserAnalyticsRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string page_id = 1;
         */
        this.pageId = "";
        /**
         * @generated from field: string url = 2;
         */
        this.url = "";
        /**
         * @generated from field: string event_type = 3;
         */
        this.eventType = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RecordBrowserAnalyticsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordBrowserAnalyticsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordBrowserAnalyticsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordBrowserAnalyticsRequest, a, b);
    }
}
RecordBrowserAnalyticsRequest.runtime = proto3;
RecordBrowserAnalyticsRequest.typeName = "exa.browser_preview_pb.RecordBrowserAnalyticsRequest";
RecordBrowserAnalyticsRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * RecordBrowserAnalyticsResponse is the response for the RecordBrowserAnalytics RPC
 *
 * @generated from message exa.browser_preview_pb.RecordBrowserAnalyticsResponse
 */
export class RecordBrowserAnalyticsResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RecordBrowserAnalyticsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordBrowserAnalyticsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordBrowserAnalyticsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordBrowserAnalyticsResponse, a, b);
    }
}
RecordBrowserAnalyticsResponse.runtime = proto3;
RecordBrowserAnalyticsResponse.typeName = "exa.browser_preview_pb.RecordBrowserAnalyticsResponse";
RecordBrowserAnalyticsResponse.fields = proto3.util.newFieldList(() => []);
